/**
 * Product classification under the EU Cyber Resilience Act (CRA).
 *
 * These are the officially recognised categories. They are shared by every
 * place the classification can be selected (create / edit / detail pages) so
 * the options can never drift apart again.
 */
export const CRA_CLASSIFICATION_OPTIONS = [
  "Critical",
  "Important I",
  "Important II",
  "Default",
  "Out of Scope",
] as const;

export type CraClassification = (typeof CRA_CLASSIFICATION_OPTIONS)[number];

/**
 * Map a CRA classification to the badge colour key understood by `getCRAColor`
 * (which is keyed by CRA applicability result codes).
 */
export function craClassificationColorKey(classification: string): string {
  switch (classification) {
    case "Critical":
      return "in_scope_critical";
    case "Important I":
    case "Important II":
      return "in_scope_important";
    case "Default":
      return "in_scope_default";
    case "Out of Scope":
      return "not_in_scope";
    default:
      return "unknown";
  }
}
